import React from 'react';
import { string } from 'prop-types';
import { utcToZonedTime } from 'date-fns-tz';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { EN_US } from '../../../utils/constants/LanguageRegionCode';

export function formatDateStringWithTimezone(dateString, locale, timezone) {
  let dateObj = new Date(dateString);
  if (timezone) {
    dateObj = utcToZonedTime(dateString, timezone);
  }

  return dateObj.toLocaleDateString(locale || EN_US, { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function CardDate({ className, dateString, locale, timezone }) {
  if (!dateString) {
    return null;
  }

  return (
    <span className={`${className} ${StringConstantsMixin.constants.XLATE.NONE}`}>{formatDateStringWithTimezone(dateString, locale, timezone)}</span>
  );
}

CardDate.propTypes = {
  className: string,
  dateString: string,
  locale: string,
  timezone: string
};
